import { UserModel } from '../modules/auth/models/UserModel';
import { Permission } from './types';

const fetchPermission =
  (user: UserModel | any) =>
  async (permission: Permission): Promise<boolean> => {
    return user?.authorization_keys?.find((e: string) => e === permission);
  };
export default fetchPermission;
